import { render, staticRenderFns } from "./VerDetalleModal.vue?vue&type=template&id=5dd3cd70&"
import script from "./VerDetalleModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports